/**
 * Custom Chart schema terms
 *
 * @package ext-components-pro
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const customChart = {
	setup: {
		label: "schema:customChart.setup#label",
		description: "schema:customChart.setup#description"
	},
	update: {
		label: "schema:customChart.callback#label",
		description: "schema:customChart.callback#description"
	},
	data: {
		label: "schema:customChart.data#label"
	}
};
